const getUnixFromDate = (date) => {
  const fecha = new Date(date);
  return fecha.getTime() / 1000;
};

export default getUnixFromDate;
